import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { SafeHTMLPipeModule } from "app/shared/pipes/safeHtml";
import { LoginBoxDialogComponent } from "./loginbox-dialog.component";
import { LoginBoxDialogService } from "./loginbox-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,

        SafeHTMLPipeModule,
    ],

    declarations: [LoginBoxDialogComponent],
    exports: [LoginBoxDialogComponent],
    providers: [LoginBoxDialogService],
})
export class LoginBoxDialogModule {}